import { render, staticRenderFns } from "./newNewslist.vue?vue&type=template&id=387f0c93&scoped=true"
import script from "./newNewslist.vue?vue&type=script&lang=js"
export * from "./newNewslist.vue?vue&type=script&lang=js"
import style0 from "./newNewslist.vue?vue&type=style&index=0&id=387f0c93&lang=css"
import style1 from "./newNewslist.vue?vue&type=style&index=1&id=387f0c93&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f0c93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387f0c93')) {
      api.createRecord('387f0c93', component.options)
    } else {
      api.reload('387f0c93', component.options)
    }
    module.hot.accept("./newNewslist.vue?vue&type=template&id=387f0c93&scoped=true", function () {
      api.rerender('387f0c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/newNews/newNewslist.vue"
export default component.exports